import React, { useEffect, useState } from "react";
import Modal from "../../../modal/modal";
import Select from "../../../select/select";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Button from "../../../button/button";
import InputDate from "../../../inputDate/inputDate";
import './addPromotionToGroup.scss'
import { PostAddPromotionToGroup } from "../../../../utils/Apis/principalApis";
const AddPromotionToGroup = ({ onClose, open, showAlert, idGroup }) => {
    const [conceptSelected, setConceptSelected] = useState('4')
    const [typeSelected, setTypeSelected] = useState('');
    const [percentageValue, setPercentageValue] = useState('');
    const [dateBegin, setDateBegin] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [disabledButton, setDisabledButton] = useState(false);
    const concepts = [
        { value: '4', label: 'Inscripción' },
        { value: '1', label: 'Colegiatura' },
    ];
    const types = [
        { value: '1', label: 'Gratis' },
        { value: '2', label: 'Porcentaje' },
        { value: '3', label: '2x1' },
    ];

    const percentages=[
        { value: '25', label: '25%' },
        { value: '50', label: '50%' },
        { value: '75', label: '75%' },
        { value: '100', label: '100%' },
    ]
    const handleTypeChange = (value) => {
        if (value !== 2) {
            setPercentageValue('')
        }
        setTypeSelected(value)
    }
    useEffect(() => {
        if (open) {
            setDateBegin('')
            setDateEnd('')
        }
    }, [open])
    const savePromotionToGroup = async () => {
        const isMissingConceptOrType = !conceptSelected || !typeSelected;
        const isMissingPercentage = Number(typeSelected) === 2 && !percentageValue;

        if (isMissingConceptOrType || isMissingPercentage) {
            return showAlert('info', 'Por favor verifica que todos los campos esten llenos');
        }
        if (!dateBegin || !dateEnd) {
            return showAlert('info', 'Selecciona las fechas')
        }
        if (dateEnd < dateBegin) {
            return showAlert('info', 'Verifique que la fecha de finalización sea mayor a la fecha inicial')
        }
        const promotioToGroup = await PostAddPromotionToGroup(idGroup, conceptSelected, typeSelected, percentageValue, dateBegin, dateEnd)
        if (promotioToGroup.status === 200) {
            setDisabledButton(true)
            showAlert('success',promotioToGroup.message)
            setTimeout(() => {
                onClose()
                setDisabledButton(false)
            }, 3500);
        }
    }
    return (
        <Modal onClose={onClose} isOpen={open} overlayClick={false}>
            <div className="add-promotion-to-group-modal">
                <h1 className="title-1">Agregar promoción a grupo</h1>
                <Select options={concepts} placeholder={'Concepto'} className={'main-color'} value={conceptSelected} onChange={(e) => { setConceptSelected(e.target.value) }} />
                <Select options={types} placeholder={'Tipo'} className={'main-color'} value={typeSelected} onChange={(e) => handleTypeChange(e.target.value)} />
                {
                    typeSelected === '2' &&
                    <Select options={percentages} placeholder={'Selecciona el porcentaje'} className={'main-color'} value={percentageValue} onChange={(e) => setPercentageValue(e.target.value)}/>
                }
                <div className="add-promotion-to-group-modal-container-dates">
                    <InputDate selectionType={'date'}
                        onChange={(date) =>
                            setDateBegin(date)
                        }
                        placeholder={"Selecciona fecha de inicio"}
                    />
                    <InputDate selectionType={'date'}
                        onChange={(date) =>
                            setDateEnd(date)
                        }
                        placeholder={"Selecciona fecha de finalizacion"}
                    />
                </div>
                <div className='confirm-buttons-section'>
                    <Button text='Cancelar' backgroundColor='red' onClick={onClose} disabled={disabledButton}></Button>
                    <Button text='Guardar' onClick={savePromotionToGroup} disabled={disabledButton}/>
                </div>
            </div>
        </Modal>
    )
}

export default AddPromotionToGroup